import { cva } from '@/styled-system/css';

export const datePickerTriggerRecipe = cva({
  base: {},
  variants: {
    size: {
      sm: {
        paddingInline: 'tight',
        borderTopRightRadius: 'obj.default',
        borderBottomRightRadius: 'obj.default',
        borderTopLeftRadius: 'none',
        borderBottomLeftRadius: 'none',
      },
      md: {
        paddingInline: 'tight',
        borderTopRightRadius: 'obj.default',
        borderBottomRightRadius: 'obj.default',
        borderTopLeftRadius: 'none',
        borderBottomLeftRadius: 'none',
      },
      lg: {
        paddingInline: 'default',
        borderTopRightRadius: 'obj.default',
        borderBottomRightRadius: 'obj.default',
        borderTopLeftRadius: 'none',
        borderBottomLeftRadius: 'none',
      },
    },
    disabled: {
      true: {},
      false: {
        boxShadow: {
          transition: {
            _motionReduce: 'none',
            _motionSafe: 'box-shadow 200ms ease',
          },
          _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
    error: {
      true: {},
      false: {},
    },
    readOnly: {
      true: {
        display: 'none',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      error: false,
      css: {
        boxShadowColor: {
          _focusVisible: 'border.action.hero.default',
        },
      },
    },
    {
      disabled: false,
      error: true,
      css: {
        boxShadowColor: {
          _focusVisible: 'border.action.critical.strong.default',
        },
      },
    },
  ],
});
